import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { Add, Delete, Edit, PlaylistAdd, PlaylistRemove } from "@mui/icons-material";

// ─── Hierarchy Map ────────────────────────────────────────────────────────────
// TODO: Replace with actual data

export const DISTRICT_HIERARCHY = {
    'Lakshadweep': ['Lakshadweep'],
    'Andaman & Nicobar Islands': ['Nicobars',
        'North & Middle Andaman',
        'South Andaman'],
    'Andhra Pradesh': ['Srikakulam',
        'Vizianagaram',
        'Visakhapatnam',
        'East Godavari',
        'West Godavari',
        'Krishna',
        'Guntur',
        'Prakasam',
        'Sri Potti Sriramulu Nello',
        'Y.S.R.',
        'Kurnool',
        'Anantapur',
        'Chittoor'],
    'Arunachal Pradesh': ['Tawang',
        'West Kameng',
        'East Kameng',
        'Papum Pare',
        'Upper Subansiri',
        'Upper Siang',
        'Changlang',
        'Lower Subansiri',
        'Dibang Valley',
        'Lower Dibang Valley',
        'Anjaw',
        'East Siang',
        'Kra Daadi',
        'Kurung Kumey',
        'Lohit',
        'Longding',
        'Namsai',
        'Siang',
        'Tirap',
        'West Siang'],
    'Assam': ['Kokrajhar',
        'Goalpara',
        'Barpeta',
        'Morigaon',
        'Lakhimpur',
        'Dhemaji',
        'Tinsukia',
        'Dibrugarh',
        'Golaghat',
        'Dima Hasao',
        'Cachar',
        'Karimganj',
        'Hailakandi',
        'Bongaigaon',
        'Chirang',
        'Kamrup',
        'Kamrup Metropolitan',
        'Nalbari',
        'Baksa',
        'Darrang',
        'Udalguri',
        'Biswanath',
        'Charaideo',
        'Dhubri',
        'Hojai',
        'Jorhat',
        'Karbi Anglong',
        'Majuli',
        'Nagaon',
        'Sivasagar',
        'Sonitpur',
        'South Salmara Mancachar',
        'West Karbi Anglong'],
    'Bihar': ['Pashchim Champaran',
        'Purba Champaran',
        'Sheohar',
        'Sitamarhi',
        'Madhubani',
        'Supaul',
        'Araria',
        'Kishanganj',
        'Purnia',
        'Katihar',
        'Madhepura',
        'Saharsa',
        'Darbhanga',
        'Muzaffarpur',
        'Gopalganj',
        'Siwan',
        'Saran',
        'Vaishali',
        'Samastipur',
        'Begusarai',
        'Khagaria',
        'Bhagalpur',
        'Banka',
        'Munger',
        'Lakhisarai',
        'Sheikhpura',
        'Nalanda',
        'Patna',
        'Bhojpur',
        'Buxar',
        'Kaimur (Bhabua)',
        'Rohtas',
        'Aurangabad',
        'Gaya',
        'Nawada',
        'Jamui',
        'Jehanabad',
        'Arwal'],
    'Chandigarh': ['Chandigarh'],
    'Chhattisgarh': ['Koriya',
        'Jashpur',
        'Raigarh',
        'Korba',
        'Janjgir - Champa',
        'Kabeerdham',
        'Rajnandgaon',
        'Mahasamund',
        'Dhamtari',
        'Uttar Bastar Kanker',
        'Narayanpur',
        'Bijapur',
        'Balod',
        'Baloda Bazar',
        'Balrampur',
        'Bastar',
        'Bemetara',
        'Bilaspur',
        'Dantewada',
        'Durg',
        'Gariyaband',
        'Kodagaon',
        'Mungeli',
        'Raipur',
        'Sukma',
        'Surajpur',
        'Surguja'],
    'Dadra And Nagar Haveli & Daman And Diu': ['Diu',
        'Daman',
        'Dadra & Nagar Haveli'],
    'Goa': ['North Goa', 'South Goa'],
    'Gujarat': ['Kachchh',
        'Banas Kantha',
        'Patan',
        'Mahesana',
        'Gandhinagar',
        'Porbandar',
        'Amreli',
        'Anand',
        'Dohad',
        'Narmada',
        'Bharuch',
        'The Dangs',
        'Navsari',
        'Valsad',
        'Surat',
        'Tapi',
        'Ahmadabad',
        'Aravali',
        'Bhavnagar',
        'Botad',
        'Chhota Udaipur',
        'Devbhumi Dwarka',
        'Gir Somnath',
        'Jamnagar',
        'Junagadh',
        'Kheda',
        'Mahisagar',
        'Morbi',
        'Panch Mahals',
        'Rajkot',
        'Sabar Kantha',
        'Surendranagar',
        'Vadodara'],
    'Haryana': ['Panchkula',
        'Ambala',
        'Yamunanagar',
        'Kurukshetra',
        'Kaithal',
        'Karnal',
        'Panipat',
        'Sonipat',
        'Jind',
        'Fatehabad',
        'Sirsa',
        'Hisar',
        'Rohtak',
        'Jhajjar',
        'Mahendragarh',
        'Rewari',
        'Gurgaon',
        'Mewat',
        'Faridabad',
        'Palwal',
        'Bhiwani',
        'Charkhi Dadri'],
    'Himachal Pradesh': ['Chamba',
        'Kangra',
        'Lahul & Spiti',
        'Kullu',
        'Mandi',
        'Hamirpur',
        'Una',
        'Bilaspur',
        'Solan',
        'Sirmaur',
        'Shimla',
        'Kinnaur'],
    'Jammu & Kashmir': ['Kupwara',
        'Badgam',
        'Punch',
        'Rajouri',
        'Kathua',
        'Baramula',
        'Bandipore',
        'Srinagar',
        'Ganderbal',
        'Pulwama',
        'Shupiyan',
        'Anantnag',
        'Kulgam',
        'Doda',
        'Ramban',
        'Kishtwar',
        'Udhampur',
        'Reasi',
        'Jammu',
        'Samba'],
    'Jharkhand': ['Garhwa',
        'Chatra',
        'Kodarma',
        'Giridih',
        'Deoghar',
        'Godda',
        'Sahibganj',
        'Pakur',
        'Dhanbad',
        'Bokaro',
        'Lohardaga',
        'Purbi Singhbhum',
        'Palamu',
        'Latehar',
        'Hazaribagh',
        'Ramgarh',
        'Dumka',
        'Jamtara',
        'Ranchi',
        'Khunti',
        'Gumla',
        'Simdega',
        'Pashchimi Singhbhum',
        'Saraikela-Kharsawan'],
    'Karnataka': ['Belgaum',
        'Bagalkot',
        'Bijapur',
        'Bidar',
        'Raichur',
        'Koppal',
        'Gadag',
        'Dharwad',
        'Uttara Kannada',
        'Haveri',
        'Bellary',
        'Chitradurga',
        'Davanagere',
        'Shimoga',
        'Udupi',
        'Chikmagalur',
        'Tumkur',
        'Bangalore',
        'Mandya',
        'Hassan',
        'Dakshina Kannada',
        'Kodagu',
        'Mysore',
        'Chamarajanagar',
        'Gulbarga',
        'Yadgir',
        'Kolar',
        'Chikkaballapura',
        'Bangalore Rural',
        'Ramanagara'],
    'Kerala': ['Kasaragod',
        'Kannur',
        'Wayanad',
        'Kozhikode',
        'Malappuram',
        'Palakkad',
        'Thrissur',
        'Ernakulam',
        'Idukki',
        'Kottayam',
        'Alappuzha',
        'Pathanamthitta',
        'Kollam',
        'Thiruvananthapuram'],
    'Ladakh': ['Leh(Ladakh)', 'Kargil'],
    'Madhya Pradesh': ['Sheopur',
        'Morena',
        'Bhind',
        'Gwalior',
        'Datia',
        'Shivpuri',
        'Tikamgarh',
        'Chhatarpur',
        'Panna',
        'Sagar',
        'Damoh',
        'Satna',
        'Rewa',
        'Umaria',
        'Neemuch',
        'Mandsaur',
        'Ratlam',
        'Ujjain',
        'Dewas',
        'Dhar',
        'Indore',
        'Khargone (West Nimar)',
        'Barwani',
        'Rajgarh',
        'Vidisha',
        'Bhopal',
        'Sehore',
        'Raisen',
        'Betul',
        'Harda',
        'Hoshangabad',
        'Katni',
        'Jabalpur',
        'Narsimhapur',
        'Dindori',
        'Mandla',
        'Chhindwara',
        'Seoni',
        'Balaghat',
        'Guna',
        'Ashoknagar',
        'Shahdol',
        'Anuppur',
        'Sidhi',
        'Singrauli',
        'Jhabua',
        'Alirajpur',
        'Khandwa (East Nimar)',
        'Burhanpur',
        'Agar Malwa',
        'Shajapur'],
    'Maharastra': ['Nandurbar',
        'Dhule',
        'Jalgaon',
        'Buldana',
        'Akola',
        'Washim',
        'Amravati',
        'Wardha',
        'Nagpur',
        'Bhandara',
        'Gondiya',
        'Gadchiroli',
        'Chandrapur',
        'Yavatmal',
        'Nanded',
        'Hingoli',
        'Parbhani',
        'Jalna',
        'Aurangabad',
        'Nashik',
        'Mumbai Suburban',
        'Mumbai',
        'Raigarh',
        'Pune',
        'Ahmadnagar',
        'Bid',
        'Latur',
        'Osmanabad',
        'Solapur',
        'Satara',
        'Ratnagiri',
        'Sindhudurg',
        'Kolhapur',
        'Sangli',
        'Palghar',
        'Thane'],
    'Manipur': ['Senapati',
        'Tamenglong',
        'Churachandpur',
        'Bishnupur',
        'Thoubal',
        'Imphal West',
        'Imphal East',
        'Ukhrul',
        'Chandel'],
    'Meghalaya': ['South Garo Hills',
        'Ribhoi',
        'East Khasi Hills',
        'East Garo Hills',
        'East Jantia Hills',
        'North Garo Hills',
        'South West Garo Hills',
        'South West Khasi Hills',
        'West Garo Hills',
        'West Jaintia Hills',
        'West Khasi Hills'],
    'Mizoram': ['Chandel',
        'Mamit',
        'Kolasib',
        'Aizawl',
        'Champhai',
        'Serchhip',
        'Lunglei',
        'Lawngtlai'],
    'Nct Of Delhi': ['Central',
        'East',
        'New Delhi',
        'North',
        'North East',
        'North West',
        'Shahdara',
        'South',
        'South East',
        'South West',
        'West'],
    'Nagaland': ['Mon',
        'Mokokchung',
        'Zunheboto',
        'Wokha',
        'Dimapur',
        'Phek',
        'Tuensang',
        'Longleng',
        'Kiphire',
        'Kohima',
        'Peren'],
    'Odisha': ['Bargarh',
        'Jharsuguda',
        'Sambalpur',
        'Debagarh',
        'Sundargarh',
        'Kendujhar',
        'Mayurbhanj',
        'Baleshwar',
        'Bhadrak',
        'Kendrapara',
        'Jagatsinghapur',
        'Cuttack',
        'Jajapur',
        'Dhenkanal',
        'Anugul',
        'Nayagarh',
        'Khordha',
        'Puri',
        'Ganjam',
        'Gajapati',
        'Kandhamal',
        'Baudh',
        'Subarnapur',
        'Balangir',
        'Nuapada',
        'Kalahandi',
        'Rayagada',
        'Nabarangapur',
        'Koraput',
        'Malkangiri'],
    'Puducherry': ['Yanam', 'Puducherry', 'Mahe', 'Karaikal'],
    'Punjab': ['Kapurthala',
        'Jalandhar',
        'Hoshiarpur',
        'Shahid Bhagat Singh Nagar',
        'Fatehgarh Sahib',
        'Ludhiana',
        'Moga',
        'Muktsar',
        'Faridkot',
        'Bathinda',
        'Mansa',
        'Patiala',
        'Amritsar',
        'Tarn Taran',
        'Rupnagar',
        'Sahibzada Ajit Singh Nagar',
        'Sangrur',
        'Barnala',
        'Fazilka',
        'Firozpur',
        'Gurdaspur',
        'Pathankot'],
    'Rajasthan': ['Ganganagar',
        'Hanumangarh',
        'Bikaner',
        'Churu',
        'Jhunjhunun',
        'Alwar',
        'Bharatpur',
        'Dhaulpur',
        'Karauli',
        'Sawai Madhopur',
        'Dausa',
        'Jaipur',
        'Sikar',
        'Nagaur',
        'Jodhpur',
        'Jaisalmer',
        'Barmer',
        'Jalor',
        'Sirohi',
        'Pali',
        'Ajmer',
        'Tonk',
        'Bundi',
        'Bhilwara',
        'Rajsamand',
        'Dungarpur',
        'Banswara',
        'Chittaurgarh',
        'Kota',
        'Baran',
        'Jhalawar',
        'Udaipur',
        'Pratapgarh'],
    'Sikkim': ['North  District',
        'West District',
        'South District',
        'East District'],
    'Tamil Nadu': ['Thiruvallur',
        'Chennai',
        'Kancheepuram',
        'Vellore',
        'Tiruvannamalai',
        'Viluppuram',
        'Salem',
        'Namakkal',
        'Erode',
        'The Nilgiris',
        'Dindigul',
        'Karur',
        'Tiruchirappalli',
        'Perambalur',
        'Ariyalur',
        'Cuddalore',
        'Nagapattinam',
        'Thiruvarur',
        'Thanjavur',
        'Pudukkottai',
        'Sivaganga',
        'Madurai',
        'Theni',
        'Virudhunagar',
        'Ramanathapuram',
        'Thoothukkudi',
        'Tirunelveli',
        'Kanniyakumari',
        'Dharmapuri',
        'Krishnagiri',
        'Coimbatore',
        'Tiruppur'],
    'Telangana': ['Adilabad',
        'Bhadradri Kothagudem',
        'Hyderabad',
        'Jagitial',
        'Jangoan',
        'Jayashankar Bhupalapally',
        'Jogulamba Gadwal',
        'Kamareddy',
        'Karimnagar',
        'Khammam',
        'Komaram Bheem Asifabad',
        'Mahabubabad',
        'Mahabubnagar',
        'Mancherial',
        'Medak',
        'Medchal-Malkajgiri',
        'Nagarkurnool',
        'Nalgonda',
        'Nirmal',
        'Nizamabad',
        'Peddapalli',
        'Rajanna Sircilla',
        'Ranga Reddy',
        'Sangareddy',
        'Siddipet',
        'Suryapet',
        'Vikarabad',
        'Wanaparthy',
        'Warangal Rural',
        'Warangal Urban',
        'Yadadri Bhuvanagiri'],
    'Tripura': ['Dhalai',
        'Gomati',
        'Khowai',
        'North Tripura',
        'Sepahijala',
        'South Tripura',
        'Unakoti',
        'West Tripura'],
    'Uttar Pradesh': ['Saharanpur',
        'Bijnor',
        'Rampur',
        'Jyotiba Phule Nagar',
        'Meerut',
        'Baghpat',
        'Gautam Buddha Nagar',
        'Bulandshahr',
        'Aligarh',
        'Mahamaya Nagar',
        'Mathura',
        'Agra',
        'Firozabad',
        'Mainpuri',
        'Bareilly',
        'Pilibhit',
        'Shahjahanpur',
        'Kheri',
        'Sitapur',
        'Hardoi',
        'Unnao',
        'Lucknow',
        'Farrukhabad',
        'Kannauj',
        'Etawah',
        'Auraiya',
        'Kanpur Dehat',
        'Kanpur Nagar',
        'Jalaun',
        'Jhansi',
        'Lalitpur',
        'Hamirpur',
        'Mahoba',
        'Banda',
        'Chitrakoot',
        'Fatehpur',
        'Pratapgarh',
        'Kaushambi',
        'Allahabad',
        'Bara Banki',
        'Faizabad',
        'Ambedkar Nagar',
        'Bahraich',
        'Shrawasti',
        'Balrampur',
        'Gonda',
        'Siddharthnagar',
        'Basti',
        'Sant Kabir Nagar',
        'Mahrajganj',
        'Gorakhpur',
        'Kushinagar',
        'Deoria',
        'Azamgarh',
        'Mau',
        'Ballia',
        'Jaunpur',
        'Ghazipur',
        'Chandauli',
        'Varanasi',
        'Sant Ravidas Nagar (Bhadohi)',
        'Mirzapur',
        'Sonbhadra',
        'Etah',
        'Kanshiram Nagar',
        'Amethi',
        'Budaun',
        'Ghaziabad',
        'Hapur',
        'Moradabad',
        'Muzaffarnagar',
        'Rae Bareli',
        'Sambhal',
        'Shamli',
        'Sultanpur'],
    'Uttarakhand': ['Uttarkashi',
        'Chamoli',
        'Rudraprayag',
        'Tehri Garhwal',
        'Dehradun',
        'Garhwal',
        'Pithoragarh',
        'Bageshwar',
        'Almora',
        'Champawat',
        'Nainital',
        'Udham Singh Nagar',
        'Hardwar'],
    'West Bengal': ['Darjiling',
        'Jalpaiguri',
        'Koch Bihar',
        'Uttar Dinajpur',
        'Dakshin Dinajpur',
        'Maldah',
        'Murshidabad',
        'Birbhum',
        'Nadia',
        'North Twenty Four Pargana',
        'Hugli',
        'Bankura',
        'Puruliya',
        'Haora',
        'Kolkata',
        'South Twenty Four Pargana',
        'Paschim Medinipur',
        'Purba Medinipur',
        'Paschim Barddhaman',
        'Purba Barddhaman']
};

export const ALL_STATES = Object.keys(DISTRICT_HIERARCHY);

// ─── Helpers ──────────────────────────────────────────────────────────────────

export const EMPTY_FORM = {
    name: "",
    description: "",
    add_default_layers: true,
    state_name: "",
    district_name: "",
    block_name: "",
    additional_properties: {},
};

const isFormValid = (data) => (data.name ?? "").trim() !== "";

// ─── Additional Properties Editor ────────────────────────────────────────────
// Simple key/value table — no required rows, user adds freely

function AdditionalPropsEditor({ props, onChange, disabled }) {
    const toRows = (obj) => Object.entries(obj ?? {}).map(([key, value]) => ({ key, value }));
    const toObj = (rows) => Object.fromEntries(rows.map(({ key, value }) => [key, value]));

    const [rows, setRows] = useState(() => toRows(props ?? {}));

    useEffect(() => { onChange(toObj(rows)); }, [rows]); // eslint-disable-line

    const setVal = (i, val) => setRows((p) => p.map((r, idx) => (idx === i ? { ...r, value: val } : r)));
    const setKey = (i, val) => setRows((p) => p.map((r, idx) => (idx === i ? { ...r, key: val } : r)));
    const addRow = () => setRows((p) => [...p, { key: "", value: "" }]);
    const removeRow = (i) => setRows((p) => p.filter((_, idx) => idx !== i));

   

    const thSx = {
        bgcolor: "primary.main",
        color: "primary.contrastText",
        fontWeight: 700,
        fontSize: 13,
        py: 1.25,
        px: 2,
        letterSpacing: 0.3,
        borderBottom: "none",
        whiteSpace: "nowrap",
    };

    return (
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1, overflow: "hidden" }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={thSx}>Key</TableCell>
                        <TableCell sx={thSx}>Value</TableCell>
                        <TableCell sx={{ ...thSx, width: 110 }} align="center">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, i) => (
                        <TableRow key={i} hover sx={{ "&:last-child td": { border: 0 } }}>
                            <TableCell sx={{ px: 2, py: 0.75, width: "40%" }}>
                                <TextField
                                    size="small"
                                    value={row.key}
                                    onChange={(e) => setKey(i, e.target.value)}
                                    disabled={disabled}
                                    placeholder="key"
                                    variant="outlined"
                                    fullWidth
                                    sx={{ "& input": { fontSize: 13 } }}
                                />
                            </TableCell>
                            <TableCell sx={{ px: 2, py: 0.75 }}>
                                <TextField
                                    size="small"
                                    value={row.value}
                                    onChange={(e) => setVal(i, e.target.value)}
                                    disabled={disabled}
                                    placeholder="value"
                                    variant="outlined"
                                    fullWidth
                                    sx={{ "& input": { fontSize: 13 } }}
                                />
                            </TableCell>
                            <TableCell align="center" sx={{ px: 1.5, py: 0.75 }}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="error"
                                    startIcon={<PlaylistRemove sx={{ fontSize: 16 }} />}
                                    onClick={() => removeRow(i)}
                                    disabled={disabled}
                                    sx={{ fontSize: 12, fontWeight: 700, textTransform: "none", px: 1.5, py: 0.4, minWidth: 0 }}
                                >
                                    Remove
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}

                    <TableRow sx={{ bgcolor: "grey.50" }}>
                        <TableCell colSpan={3} sx={{ px: 2, py: 1, border: 0 }}>
                            <Button
                                size="small"
                                variant="contained"
                                color="success"
                                startIcon={<PlaylistAdd sx={{ fontSize: 16 }} />}
                                onClick={addRow}
                                disabled={disabled}
                                sx={{ fontSize: 12, fontWeight: 700, textTransform: "none", px: 1.5, py: 0.4 }}
                            >
                                Add
                            </Button>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

// ─── Project Form Fields ──────────────────────────────────────────────────────

function ProjectFormFields({ data, onChange, disabled, showDefaultLayers }) {
    const districts = data.state_name ? (DISTRICT_HIERARCHY[data.state_name] ?? []) : [];

    const handleStateChange = (state) => {
        onChange({ ...data, state_name: state, district_name: "", block_name: "" });
    };

    const handleDistrictChange = (district) => {
        onChange({ ...data, district_name: district, block_name: "" });
    };

    return (
        <Stack spacing={2.5} sx={{ pt: 0.5 }}>
            {/* Name */}
            <TextField
                fullWidth
                label="Project Name"
                value={data.name ?? ""}
                onChange={(e) => onChange({ ...data, name: e.target.value })}
                disabled={disabled}
                required
                size="small"
                error={!data.name?.trim()}
                helperText={!data.name?.trim() ? "Required" : ""}
            />

            {/* Description */}
            <TextField
                fullWidth
                label="Description"
                multiline
                minRows={2}
                maxRows={4}
                value={data.description ?? ""}
                onChange={(e) => onChange({ ...data, description: e.target.value })}
                disabled={disabled}
                size="small"
            />

            {/* Default Layers toggle — only on Create */}
            {showDefaultLayers && (
                <FormControlLabel
                    control={
                        <Switch
                            checked={data.add_default_layers ?? true}
                            onChange={(e) => onChange({ ...data, add_default_layers: e.target.checked })}
                            disabled={disabled}
                            size="small"
                            color="primary"
                        />
                    }
                    label={
                        <Typography variant="body2" color="text.secondary">
                            Add default layers (POP, OFC, Landmark, Crossing…)
                        </Typography>
                    }
                />
            )}

            {/* ── Location ── */}
            <Box>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    Location
                </Typography>
                <Stack spacing={1.5}>
                    {/* State dropdown */}
                    <FormControl fullWidth size="small" disabled={disabled}>
                        <InputLabel>State</InputLabel>
                        <Select
                            value={data.state_name ?? ""}
                            label="State"
                            onChange={(e) => handleStateChange(e.target.value)}
                        >
                            <MenuItem value=""><em>— None —</em></MenuItem>
                            {ALL_STATES.map((s) => (
                                <MenuItem key={s} value={s}>
                                    {s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* District dropdown — cascades from state */}
                    <FormControl fullWidth size="small" disabled={disabled || !data.state_name}>
                        <InputLabel>District</InputLabel>
                        <Select
                            value={data.district_name ?? ""}
                            label="District"
                            onChange={(e) => handleDistrictChange(e.target.value)}
                        >
                            <MenuItem value=""><em>— None —</em></MenuItem>
                            {districts.map((d) => (
                                <MenuItem key={d} value={d}>{d}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {/* Block — free text input */}
                    <TextField
                        fullWidth
                        label="Block"
                        size="small"
                        value={data.block_name ?? ""}
                        onChange={(e) => onChange({ ...data, block_name: e.target.value })}
                        disabled={disabled}
                        placeholder="Enter block name"
                    />
                </Stack>
            </Box>

            {/* ── Additional Properties ── */}
            <Box>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                    Additional Properties
                    <Typography component="span" variant="caption" color="text.disabled" sx={{ ml: 1, fontWeight: 400 }}>
                        optional
                    </Typography>
                </Typography>
                <AdditionalPropsEditor
                    props={data.additional_properties ?? {}}
                    onChange={(updated) => onChange({ ...data, additional_properties: updated })}
                    disabled={disabled}
                />
            </Box>
        </Stack>
    );
}

// ─── Create Dialog ────────────────────────────────────────────────────────────

export function CreateProjectDialog({ open, onClose, onCreated, loading }) {
    const [form, setForm] = useState(EMPTY_FORM);

    const handleClose = () => {
        if (loading) return;
        setForm(EMPTY_FORM);
        onClose();
    };

    const handleSubmit = () => {
        onCreated(form, () => {
            setForm(EMPTY_FORM);
        });
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth disableRestoreFocus disableEnforceFocus keepMounted>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 700, pb: 1, borderBottom: "1px solid", borderColor: "divider" }}>
                <Add color="primary" fontSize="small" />
                Create New Project
            </DialogTitle>

            <DialogContent sx={{ pt: "20px !important" }}>
                <ProjectFormFields
                    data={form}
                    onChange={setForm}
                    disabled={loading}
                    showDefaultLayers
                />
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, gap: 1, borderTop: "1px solid", borderColor: "divider" }}>
                <Button onClick={handleClose} disabled={loading} color="inherit">Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={loading || !isFormValid(form)}
                    startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <Add />}
                >
                    {loading ? "Creating…" : "Create"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

// ─── Edit Dialog ──────────────────────────────────────────────────────────────

export function EditProjectDialog({ open, onClose, project, onEdited, loading }) {
    const [form, setForm] = useState(EMPTY_FORM);

    // Sync form when project prop changes
    useEffect(() => {
        if (project) {
            setForm({
                name: project.name ?? "",
                description: project.description ?? "",
                add_default_layers: project.add_default_layers ?? false,
                state_name: project.state_name ?? "",
                district_name: project.district_name ?? "",
                block_name: project.block_name ?? "",
                additional_properties: project.additional_properties ?? {},
            });
        }
    }, [project]);

    const handleClose = () => {
        if (loading) return;
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth disableRestoreFocus disableEnforceFocus keepMounted>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 700, pb: 1, borderBottom: "1px solid", borderColor: "divider" }}>
                <Edit color="primary" fontSize="small" />
                Edit Project
                {project?.id && (
                    <Typography variant="caption" color="text.disabled" sx={{ ml: "auto", fontWeight: 400 }}>
                        ID: {project.id}
                    </Typography>
                )}
            </DialogTitle>

            <DialogContent sx={{ pt: "20px !important" }}>
                <ProjectFormFields
                    data={form}
                    onChange={setForm}
                    disabled={loading}
                    showDefaultLayers={false}
                />
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, gap: 1, borderTop: "1px solid", borderColor: "divider" }}>
                <Button onClick={handleClose} disabled={loading} color="inherit">Cancel</Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => onEdited(project.id, form)}
                    disabled={loading || !isFormValid(form)}
                    startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <Edit />}
                >
                    {loading ? "Saving…" : "Save Changes"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

// ─── Delete Dialog ────────────────────────────────────────────────────────────

export function DeleteProjectDialog({ open, onClose, projectId, onDeleted, loading }) {
    return (
        <Dialog open={open} onClose={() => !loading && onClose()} maxWidth="xs" fullWidth>
            <DialogTitle fontWeight={700}>Confirm Delete</DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="text.secondary">
                    This will permanently delete the project and all associated data. This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
                <Button onClick={onClose} disabled={loading} color="inherit">Cancel</Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={() => onDeleted(projectId)}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <Delete />}
                >
                    {loading ? "Deleting…" : "Delete"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}